import * as React from "react";

export const StarIcon = ({ color = "#191D3A", ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
        <g clipPath="url(#clip0_2200_7555)">
            <path d="M19.9477 7.67148C19.816 7.2665 19.4568 6.97978 19.0335 6.94148L13.2601 6.41734L10.9784 1.07545C10.81 0.682988 10.4267 0.429688 10 0.429688C9.57338 0.429688 9.18992 0.682988 9.02253 1.07545L6.74085 6.41734L0.96652 6.94148C0.543234 6.98055 0.184799 7.26726 0.0523506 7.67148C-0.0793349 8.07645 0.0422796 8.52064 0.362414 8.80141L4.72665 12.6282L3.43986 18.2957C3.34571 18.7125 3.50746 19.1434 3.85323 19.3933C4.03908 19.5284 4.25744 19.5958 4.47656 19.5958C4.66485 19.5958 4.8533 19.5458 5.02161 19.445L10 16.4683L14.9775 19.445C15.3427 19.6633 15.8018 19.6433 16.1468 19.3933C16.4926 19.1434 16.6543 18.7125 16.5602 18.2957L15.2734 12.6282L19.6376 8.80141C19.9576 8.52064 20.0794 8.07737 19.9477 7.67148Z" fill={color} />
        </g>
        <defs>
            <clipPath id="clip0_2200_7555">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
);